import { BranchFreePlanLimit } from 'types/branch_free_plan_limit'
import axiosForGigbaseBiz from '../config'
import { DataResponse } from '../response'
import { mergeURL } from './lib'

const resource = 'branch_free_plan_limits'

export const requests = {
  fetchMe: async () => {
    return axiosForGigbaseBiz.get<DataResponse<BranchFreePlanLimit>>(
      mergeURL(resource, 'mine'),
    )
  },
}
